import { MapPin, Phone, Mail, Instagram, Facebook, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const contactInfo = [{
  id: "address",
  label: "Our Location",
  value: "Alexiou Building, Ifigenias 62, 3rd Floor, Nicosia 2003\nBy appointment only",
  icon: MapPin
}, {
  id: "phone",
  label: "Call for Appointment",
  value: "+357 99 433537",
  icon: Phone
}, {
  id: "email",
  label: "General Inquiries",
  value: "bodywerkscy@gmail.com",
  icon: Mail
}];
const socialLinks = [{
  id: "instagram",
  icon: Instagram,
  url: "https://www.instagram.com/bodywerkscy/"
}, {
  id: "facebook",
  icon: Facebook,
  url: "https://www.facebook.com/bodywerksCY"
}, {
  id: "whatsapp",
  icon: MessageCircle,
  url: "https://wa.me/35799433537"
}];
export default function ContactDetails() {
  return <section data-section-id="125160" id="clinic-details" className="bg-background text-foreground py-[160px]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col gap-12">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground tracking-tight">
                Visit Our Clinic
              </h2>
              <p className="text-lg text-muted-foreground font-sans max-w-md">
                Expert chiropractic care in Nicosia, at Ifigenias 62, by appointment. Our dedicated team is ready to help you on your journey to recovery.
              </p>
            </div>

            <div className="flex flex-col gap-10">
              {contactInfo.map((item, i) => <div key={item.id} data-index={i} className="flex gap-6 items-start group">
                  <div className={`mt-1 p-3 rounded-full transition-colors group-hover:bg-primary group-hover:text-primary-foreground ${item.id === 'address' || item.id === 'phone' ? 'bg-[#F58220]/10 text-[#F58220]' : 'bg-accent text-accent-foreground'}`}>
                    <item.icon className="size-6" />
                  </div>
                  <div className="space-y-2">
                    <h3 className={`text-sm font-sans font-bold uppercase tracking-widest ${item.id === 'address' || item.id === 'phone' ? 'text-[#F58220]' : 'text-accent'}`}>
                      {item.label}
                    </h3>
                    <p className={`font-sans whitespace-pre-line leading-relaxed text-lg ${item.id === 'address' || item.id === 'phone' ? 'text-[#F58220]' : 'text-foreground'}`}>
                      {item.value}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="pt-6 border-t border-border">
              <h3 className="text-sm font-sans font-bold uppercase tracking-widest text-accent mb-6">
                Connect With Us
              </h3>
              <div className="flex gap-4">
                {socialLinks.map((link, i) => <Button key={link.id} data-index={i} variant="outline" size="icon" asChild className="rounded-full border-border hover:border-accent hover:text-accent-foreground hover:bg-accent transition-all size-12">
                    <Link to={link.url}>
                      <link.icon className="size-5" />
                      <span className="sr-only">{link.id}</span>
                    </Link>
                  </Button>)}
              </div>
            </div>
          </div>

          {}
          <div className="relative w-full h-full min-h-[500px] lg:min-h-[700px]">
            <Card className="absolute inset-0 border border-border rounded-3xl bg-card backdrop-blur-md p-2 shadow-2xl shadow-shadow-color/10">
              <div className="w-full h-full bg-muted rounded-2xl relative overflow-hidden flex items-center justify-center">
                
                {}
                <div className="absolute inset-0 opacity-20">
                  <div className="absolute top-1/4 left-[-10%] w-[120%] h-3 bg-accent transform -rotate-12"></div>
                  <div className="absolute top-2/3 left-[-10%] w-[120%] h-5 bg-accent transform rotate-6"></div>
                  <div className="absolute top-[-10%] left-1/3 w-4 h-[120%] bg-accent transform rotate-45"></div>
                  <div className="absolute top-[-10%] right-1/4 w-2 h-[120%] bg-accent transform -rotate-12"></div>
                  
                  {}
                  <div className="absolute bottom-0 right-0 w-64 h-64 bg-chart-4 rounded-tl-full opacity-30 blur-2xl"></div>
                </div>

                {}
                <div className="relative z-10 flex flex-col items-center">
                  <div className="w-16 h-16 bg-accent/20 rounded-full flex items-center justify-center animate-pulse">
                    <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center shadow-lg shadow-accent/50">
                      <MapPin className="text-accent-foreground size-5" />
                    </div>
                  </div>
                  <div className="mt-4 px-4 py-2 bg-background/90 backdrop-blur-sm rounded-full border border-border shadow-lg">
                    <p className="text-sm font-sans font-medium text-foreground">Nicosia Clinic</p>
                  </div>
                </div>

                {}
                <div className="absolute bottom-4 right-4 flex flex-col gap-2">
                  <div className="w-8 h-8 bg-background/80 backdrop-blur-sm rounded-full border border-border flex items-center justify-center text-foreground font-bold text-lg cursor-not-allowed">+</div>
                  <div className="w-8 h-8 bg-background/80 backdrop-blur-sm rounded-full border border-border flex items-center justify-center text-foreground font-bold text-lg cursor-not-allowed">-</div>
                </div>

              </div>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}